import React, { memo } from "react";
import { colors } from "theme";

const styles = {
  body: {
    color: colors.textColor,
    fontSize: 24,
    fontWeight: "700",
  },
};
export const Text = memo(({ style, children, ...rest }) => {
  return (
    <span
      className="title-head"
      style={{
        ...styles.body,
        ...style,
      }}
      {...rest}
    >
      {children}
    </span>
  );
});
